import React, { useEffect, useState } from 'react';
import { Icon } from '../../icon';
import { has, is } from '../../../services/classify';
import shortid from 'shortid';
import { OptionsItemVariant } from '../OptionsEnum';
import { Text, TextMarkup } from '../../text';
import { hashClass } from '../../../helpers';
import clsx from 'clsx';
import { useTrilogyContext } from '../../../context';
/**
 * Options Item Component
 * @deprecated
 * @param id {string} Id for Options Item - Default id generated by default
 * @param className {string} Additionnal CSS Classes
 * @param variant {OptionsItemVariant} Variant for OptionsItem (ICON|MULTILINE)
 * @param iconName {IconName} Custom icon
 * @param description {String} Optional description for "multiline" label
 * @param disabled {boolean} Disabled Options Item
 * @param name {string} Options Item name
 * @param value {string} Value for options item
 * @param checked {boolean} Checked options item
 * @param label {string} Label for options item
 * @param readonly {boolean} readonly options item
 * @param onChange {onChange} onChange Event
 * @param onClick {onClick} onClick Event
 * @param children {React.ReactNode}
 */
const OptionsItem = ({ id = shortid.generate(), className, disabled, variant, iconName, description, name, value, checked, label, readonly, onChange, onClick, testId, ...others }) => {
    const { styled } = useTrilogyContext();
    const classes = hashClass(styled, clsx('field', variant && variant === OptionsItemVariant.ICON ? has(`${variant}`) : is(`${variant}`), className));
    const [_checked, setChecked] = useState(Boolean(checked) || false);
    const multilineClass = hashClass(styled, clsx(variant && variant == OptionsItemVariant.MULTILINE ? 'is-descriptive' : ''));
    useEffect(() => {
        if (!readonly) {
            setChecked(checked || false);
        }
    }, [readonly, checked]);
    return (React.createElement("div", { className: classes, ...others },
        React.createElement("div", { className: hashClass(styled, clsx('control')) },
            React.createElement("input", { type: 'radio', id: id, "data-testid": testId, name: name, value: value, disabled: disabled, checked: readonly ? checked : _checked, onChange: (e) => {
                    return e;
                }, onClick: (e) => {
                    e.stopPropagation();
                    const target = e.target;
                    if (!readonly && target.checked !== undefined) {
                        setChecked(target.checked);
                    }
                    target.value = value || '';
                    if (onChange) {
                        onChange({
                            optionId: target.id,
                            optionValue: target.value,
                            optionName: target.name,
                            optionChecked: target.checked,
                        });
                    }
                    if (onClick) {
                        onClick({
                            optionId: target.id,
                            optionValue: target.value,
                            optionName: target.name,
                            optionChecked: target.checked,
                        });
                    }
                } }),
            React.createElement("label", { htmlFor: id, className: multilineClass },
                label,
                variant && iconName && React.createElement(Icon, { name: iconName, ...others }),
                variant && variant == OptionsItemVariant.MULTILINE && description && (React.createElement(Text, { markup: TextMarkup.SPAN }, description))))));
};
export default OptionsItem;
//# sourceMappingURL=OptionsItem.js.map